




import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import { French } from 'flatpickr/dist/l10n/fr'

@Component
export default class FormDatepicker extends Vue {
    @Prop({ type: Object, default: () => ({}) }) options!: any
    @Prop({ type: String }) value!: string
    @Prop({ type: Boolean }) disabled!: boolean
    @Prop({ type: String, default: 'single' }) mode!: string
    @Prop({ type: String, default: 'Y-m-d' }) dateFormat!: string
    @Prop({ type: [String, Date], default: null }) minDate!: string | Date | null
    @Prop({ type: String, default: 'form-control-lg form-control input flatpickr-range-input' }) altInputClass!: string

    flatpickr: any = false

    $refs!: {
        datepicker: HTMLElement
    }

    @Watch('value')
    onValueChanged(val: string) {
        this.flatpickr.setDate(val)
    }

    mounted() {
        const overrideOptions = Object.assign(
            {},
            {
                altInput: this.dateFormat !== 'Y-m-d',
                altInputClass: this.altInputClass,
                altFormat: this.dateFormat,
                dateFormat: 'Y-m-d',
                onChange: this.onChange,
                onClose: this.onClose,
                onOpen: this.onOpen,
                onReady: this.onReady,
                mode: this.mode,
                locale: French,
                minDate: this.minDate,
            },
            this.options
        )

        this.flatpickr = flatpickr(this.$refs.datepicker, overrideOptions)
    }

    onChange(selectedDates: unknown[], dateStr: string, instance: unknown) {
        if (this.options.onChange) {
            this.options.onChange(selectedDates, dateStr, instance)
        }
        this.$emit('change', { selectedDates, dateStr, instance })
        this.$emit('input', dateStr)
    }

    onClose(selectedDates: unknown[], dateStr: string, instance: unknown) {
        if (this.options.onClose) {
            this.options.onClose(selectedDates, dateStr, instance)
        }

        this.$emit('close', { selectedDates, dateStr, instance })
    }

    onOpen(selectedDates: unknown[], dateStr: string, instance: unknown) {
        if (this.options.onOpen) {
            this.options.onOpen(selectedDates, dateStr, instance)
        }

        this.$emit('open', { selectedDates, dateStr, instance })
    }

    onReady(e: Event) {
        if (this.options.onReady) {
            this.options.onReady(e)
        }

        this.$emit('ready')
    }
}
